// Parse rich-text HTML without touching the live document.
//
// `document.createElement("div").innerHTML = html` builds elements owned by a
// document that has a browsing context, so `<img src=x onerror=…>` starts
// loading and fires its handler during normalization — before TipTap's schema
// gets a chance to drop the attribute. Stored content reaches these passes
// verbatim on editor load, so a payload saved through the API executes for
// anyone who opens the editor. A document from `createHTMLDocument` has no
// browsing context: nothing loads and no handler runs.
//
// Create replacement nodes from `container.ownerDocument`, never from
// `document`, or they land back in the live document and reopen the hole.
export function parseInertHTML(html) {
  const container = document.implementation.createHTMLDocument("").createElement("div")
  container.innerHTML = html

  return container
}
